import AllAuctionTable from "../pages/buyerAuction/buyer/Home/Tables/AllAuctionTable";
import PaidEmd from "../pages/buyerAuction/buyer/Home/Tables/PaidEmd";
import PcbOffer from "../pages/buyerAuction/buyer/Home/Tables/PcbOffer";
import TodayAuction from "../pages/buyerAuction/buyer/Home/Tables/TodayAuction";
import UpcommingAuction from "../pages/buyerAuction/buyer/Home/Tables/UpcommingAuction";
import AllEventTable from "../pages/sellerAuction/comman/AllEventTable";
import CompleteAuctionTable from "../pages/sellerAuction/comman/CompleteAuctionTable";
import TodayAuctionTable from "../pages/sellerAuction/comman/TodayAuctionTable";
import UpcommingAuctionTable from "../pages/sellerAuction/comman/UpcommingAuctionTable";

export const auctionTableComponents = {
    1: AllEventTable,
    2: TodayAuctionTable,
    3: UpcommingAuctionTable,
    4: CompleteAuctionTable,
  };

  export const buyerTableComponents={
    1:AllAuctionTable,
    2:TodayAuction,
    3:UpcommingAuction,
    4:PaidEmd,
    5:PcbOffer
  }